import React from "react";
import clsx from "clsx";
import { P_Props } from "./Dot.type";

const DotPresenter: React.FC<P_Props> = (props) => {
  const classes = clsx({ "dot-comp": true, [props.className || ""]: Boolean(props.className) });

  return <div className={classes} style={props.style}></div>;
};

export default DotPresenter;
